import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const useAuth=()=>{
    const jwt_token = localStorage.getItem('token')
    if(jwt_token){
        return true
    }
    else {
        return false
    }
}

const PrivateRoute=()=>{
    const auth = useAuth();
    // debugger
    return (auth === true ? <Outlet/> : <Navigate to="/login"/>)
    
}

export default PrivateRoute;